import Header from './Header/Header';
import Table from 'components/base/Table';
import useTableLayout from './useTableLayout/useTableLayout';
import { TableNoLeftRightBorders } from 'components/base/layout-components';
import LoadingTable from './LoadingTable';
import { handleEditTableMetricsClick } from './GroupMetricsTable.service';
import useGroupTableData from '../hooks/useGroupTableData/useGroupTableData';
import { getMetricsNamesToFetch } from '../groupDashboard.service';
import { uniq } from 'lodash';
import { useMemo } from 'react';

const GroupMetricsDashboardTable = ({
  selectedGroup,
  contributorsById,
  availableMetricsWidgets,
  toggleModal,
  tableColsMetricsNamesInitialStateSettingValue,
  tableMetricsNames,
  setTableMetricsNames,
  tableColsTitlesInitialStateModal,
  updateSetting,
  isCustomizeMetrics,
  gitScopeToggle
}) => {
  const metricsNames = useMemo(
    () => uniq(getMetricsNamesToFetch(tableMetricsNames)),
    [tableMetricsNames]
  );

  const {
    isLoading: metricsLoading,
    metrics,
    metricsPerGranularityLoading,
    metricsPerGranularity,
    aggregatedLastPeriodMetrics,
    metricsPerGranularityLastPeriod,
    lastPeriodDates
  } = useGroupTableData({ selectedGroup, metricsNames, gitScopeToggle });

  const isLoading =
    !availableMetricsWidgets.length ||
    metricsLoading ||
    metricsPerGranularityLoading ||
    !tableColsMetricsNamesInitialStateSettingValue;

  const teams = selectedGroup?.[0]?.children || [];
  const groupId = selectedGroup?.[0]?.id;

  const { cols, rows } = useTableLayout({
    teams,
    selectedGroup,
    contributorsById,
    metrics,
    tableMetricsNames,
    availableMetricsWidgets,
    metricsPerGranularity,
    aggregatedLastPeriodMetrics,
    metricsPerGranularityLastPeriod,
    lastPeriodDates
  });

  return (
    <>
      <Header
        teams={teams}
        isCustomizeMetrics={isCustomizeMetrics}
        onClick={() =>
          handleEditTableMetricsClick(
            toggleModal,
            availableMetricsWidgets,
            setTableMetricsNames,
            tableColsTitlesInitialStateModal,
            updateSetting,
            groupId
          )
        }
      />
      {isLoading ? (
        <LoadingTable cols={cols} />
      ) : (
        <TableNoLeftRightBorders data-cy='group-teams-metrics-table'>
          <Table
            data={rows}
            columns={cols}
            isRowsDefaultExpanded={true}
            isRowsExpandable={true}
          />
        </TableNoLeftRightBorders>
      )}
    </>
  );
};

export default GroupMetricsDashboardTable;
